import { Resource } from './types'

export const resources: Resource[] = [
  {
    resourceId: '1',
    name: 'Resource 1',
    organizationId: '1',
    userId: '1',
    createdAt: '2025-03-06T00:00:00.000Z',
    createdBy: 'Tobias Sernhede',
    lastModifiedAt: '2025-03-06T10:26:00.000Z',
    lastModifiedBy: 'Tobias Sernhede',
    editHistory: [
      {
        actionType: 'Created',
        actor: 'Tobias Sernhede',
        timestamp: '2025-03-06T00:00:00.000Z',
      },
      {
        actionType: 'Updated',
        actor: 'Tobias Sernhede',
        timestamp: '2025-03-06T10:26:00.000Z',
      },
    ],
    archivedBy: null,
    archivedAt: null,
  },
  {
    resourceId: '2',
    name: 'Resource 2',
    organizationId: '1',
    userId: '1',
    createdAt: '2025-03-05T00:00:00.000Z',
    createdBy: 'Tobias Sernhede',
    lastModifiedAt: '2025-03-05T21:13:00.000Z',
    lastModifiedBy: 'Tobias Sernhede',
    editHistory: [
      {
        actionType: 'Created',
        actor: 'Tobias Sernhede',
        timestamp: '2025-03-05T00:00:00.000Z',
      },
      {
        actionType: 'Updated',
        actor: 'Tobias Sernhede',
        timestamp: '2025-03-05T21:13:00.000Z',
      },
    ],
    archivedBy: null,
    archivedAt: null,
  },
  {
    resourceId: '3',
    name: 'Resource 3',
    organizationId: '1',
    userId: '1',
    createdAt: '2025-03-04T00:00:00.000Z',
    createdBy: 'Tobias Sernhede',
    lastModifiedAt: '2025-03-05T22:32:00.000Z',
    lastModifiedBy: 'Tobias Sernhede',
    editHistory: [
      {
        actionType: 'Created',
        actor: 'Tobias Sernhede',
        timestamp: '2025-03-04T00:00:00.000Z',
      },
    ],
    archivedBy: null,
    archivedAt: null,
  },
]

export const generateNewResource = (name: string) => ({
  resourceId: String(new Date().getTime()),
  name,
  organizationId: '1',
  userId: '1',
  createdAt: new Date().toISOString(),
  createdBy: 'Tobias Sernhede',
  lastModifiedAt: null,
  lastModifiedBy: null,
  editHistory: [],
  archivedBy: null,
  archivedAt: null,
})

export const generateUpdatedResource = (resourceId: string, name: string) => {
  const resource = resources.find((resource) => resource.resourceId === resourceId)

  if (!resource) {
    return generateNewResource(name)
  }

  return {
    ...resource,
    name,
    lastModifiedAt: new Date().toISOString(),
    lastModifiedBy: 'Tobias Sernhede',
    editHistory: [
      ...resource.editHistory,
      {
        actionType: 'Updated',
        actor: 'Tobias Sernhede',
        timestamp: new Date().toISOString(),
      },
    ],
    archivedBy: null,
    archivedAt: null,
  }
}
